import { View, Utils } from '../vendor/kerneljs';

const Reveal = View.extend({
	events: {
		'click .js--reveal-trigger': 'triggerClickHandler'
	},
	initialize: function () {
		this.trigger = this.find('.js--reveal-trigger');
		this.content = this.find('.js--reveal-content');

		let contentStyle = window.getComputedStyle ? getComputedStyle(this.content, null) : this.content.currentStyle;

		this.responsive = this.el.dataset.responsive;

		/*
			If the content element has additional classes outside of js--reveal-content (assuming addition styling is in play),
			use the set display property; otherwise default to 'inline'
		*/
		this.contentDisplayValue = this.content.classList.length > 1 ? contentStyle.display : 'inline';

		this.content.setAttribute('style', 'display:none;')

		this.el.addEventListener('reveal:trigger', this.triggerClickHandler.bind(this));

		if (this.responsive) {

			//for the inital page load
			window.onload = (event) => {
				setTimeout(this.adjustContent());
			}
			//for when you render reveal buttons in a partial view without loading the entire page
			if(document.readyState === "complete"){
				setTimeout(this.adjustContent());
			}
		}
	},
	triggerClickHandler: function () {
		this.trigger.setAttribute('style', 'display:none;');
		this.content.setAttribute('style', 'opacity:0;display:' + this.contentDisplayValue + ';');
		window.requestAnimationFrame(function () {
			this.content.setAttribute('style', 'opacity:1;display:' + this.contentDisplayValue + ';');
		}.bind(this));
	},
	adjustContent: function () {
		this.revealWidth = this.el.offsetWidth;
		this.elements = Array.from(this.find('.js--reveal-element'));

		let totalAggregatedWidth = Math.ceil(this.trigger.offsetWidth) + 40; // Total width of "See more"-button as starting point


		// Starts populating array when the container is "filled"
		const elementsNotToShow = this.elements.filter(elem => {
			const style = window.getComputedStyle ? getComputedStyle(elem, null) : elem.currentStyle;
			let elemMargins = Math.ceil(parseInt(style.marginLeft)) + Math.ceil(parseInt(style.marginRight));
			let elemTotalWidth = Math.ceil(elem.offsetWidth) + elemMargins;

			totalAggregatedWidth += elemTotalWidth;

			// elemMargins refers to "see more"-elem's margins
			let tooWide = totalAggregatedWidth > this.revealWidth;
			return !!(tooWide);
		})
		if (elementsNotToShow.length === 0) {
			this.trigger.remove();
		}

		// Places elems in correct container
		this.elements.map(elem => {
			if (elementsNotToShow.includes(elem)) {
				this.content.insertBefore(elem, null);
			}
			return null
		})
	}
});

(function () {

	function init() {
		Utils.each(Utils.find('.js--reveal'), function (elem) {
			if (!Utils.hasClass(elem, 'is-bound')) {
				Utils.addClass(elem, 'is-bound');
				new Reveal({ el: elem });
			}
		});
	};

	init();
	window.addEventListener('reveal:init', init);

})();

export default Reveal;